import { changeEventSchema } from './change-event.js';
import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
const commitSchema = z.object({
    timestamp: z.date(),
    changeEvents: z.array(changeEventSchema),
});
export function toCommit(props) {
    const result = commitSchema.safeParse(props);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid Commit object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=commit.js.map